export enum Message {
    ERROR = "error",
    NO_RECORDS = "no_records",
}